<template>
  <div class="landing">
    <BlogNav />

    <!-- HERO -->
    <section class="hero">
      <div class="hero-inner">
        <h1 class="hero-title">
          <span class="font-bold">FAQ</span>
        </h1>
        <p class="hero-sub">
          Toutes vos questions sur <strong>Query Juriste</strong>
        </p>
      </div>
    </section>

    <!-- FAQ SECTION -->
    <section class="faq-section">
      <div class="faq-inner">

        <!-- Question 1 -->
        <div class="faq-item">
          <h2 class="faq-question">Qu'est-ce que Query Juriste, et à quoi sert-il ?</h2>
          <div class="faq-answer">
            <p>
              Query est une IA de recherche juridique approfondie, conçue spécifiquement
              pour dépasser les limites des chatbots traditionnels.
            </p>
            <p>
              L'idée est, plutôt que de fournir une réponse instantanée, notre système
              engage une recherche en profondeur pendant 7 à 9 minutes, raisonne comme
              un juriste, et produit une note juridique structurée, nuancée et
              rigoureusement sourcée, équivalente au travail d'un collaborateur junior.
            </p>
          </div>
        </div>

        <!-- Question 2 -->
        <div class="faq-item">
          <h2 class="faq-question">Qui se cache derrière Query Juriste ?</h2>
          <div class="faq-answer">
            <p>
              Query repose sur trois co-fondateurs aux profils complémentaires :
              Étienne, l'ingénieur suisse mais pas protestant ; Émile, le commercial ;
              et Maxence, le juriste.
            </p>
            <p>
              Tous trois pilotent le projet avec précision, accompagnés d'une équipe
              talentueuse et dévouée.
            </p>
          </div>
        </div>

        <!-- Question 3 -->
        <div class="faq-item">
          <h2 class="faq-question">Query est-il disponible en plusieurs langues ?</h2>
          <div class="faq-answer">
            <p>
              Oui, tout à fait.
            </p>
            <p>
              Vous pouvez poser vos questions dans n'importe quelle langue : Query vous
              répondra automatiquement en français.
            </p>
            <p>
              Si vous préférez recevoir la réponse dans une autre langue, il suffit
              simplement de le préciser dans votre demande.
            </p>
          </div>
        </div>

        <!-- Question 4 -->
        <div class="faq-item">
          <h2 class="faq-question">Quelles sont les sources sur lesquelles Query s'appuie ?</h2>
          <div class="faq-answer">
            <p>Query s'appuie notamment sur :</p>
            <ul class="faq-list">
              <li>
                <img class="check" src="@/assets/check.svg" alt="" />
                L'ensemble des codes de lois
              </li>
              <li>
                <img class="check" src="@/assets/check.svg" alt="" />
                La jurisprudence en Open Data (plus de 2,7 millions de décisions
                judiciaires et administratives), ainsi que la jurisprudence de la CJUE
              </li>
              <li>
                <img class="check" src="@/assets/check.svg" alt="" />
                Les règlements et directives européens
              </li>
              <li>
                <img class="check" src="@/assets/check.svg" alt="" />
                Des sources complémentaires couvrant certaines spécialités du droit
              </li>
            </ul>
          </div>
        </div>

        <!-- Question 5 -->
        <div class="faq-item">
          <h2 class="faq-question">Où mes données sont-elles hébergées ?</h2>
          <div class="faq-answer">
            <p>
              Toutes les données des utilisateurs sont hébergées chez
              <strong>Scaleway</strong>, une entreprise française assurant une
              souveraineté totale.
            </p>
          </div>
        </div>

        <!-- Question 6 -->
        <div class="faq-item">
          <h2 class="faq-question">Query réutilise-t-il mes données pour entraîner des modèles ?</h2>
          <div class="faq-answer">
            <p>
              <strong>Non.</strong> Query ne réutilise aucune donnée utilisateur pour
              l'entraînement de ses modèles.
            </p>
          </div>
        </div>

        <!-- Question 7 -->
        <div class="faq-item">
          <h2 class="faq-question">Comment obtenir de l'aide en cas de problème ou de question ?</h2>
          <div class="faq-answer">
            <p>
              Pour toute interrogation, vous pouvez nous contacter à l'adresse
              <a href="mailto:contact@query-juriste.com" class="email-link">contact@query-juriste.com</a> :
              notre équipe vous répondra avec plaisir.
            </p>
          </div>
        </div>

      </div>
    </section>

    <!-- CTA BAND -->
    <section class="cta-band">
      <div class="cta-inner">
        <div class="cta-copy">
          <h3 class="cta-title">Une démo personnalisée, sans engagement</h3>
          <p class="cta-text">
            Découvrez comment notre outil révolutionne le travail des avocats et juristes.
          </p>
        </div>

        <div class="cta-form">
          <a
            class="btn btn-ghost rounded-pill"
            href="https://calendly.com/d/cytz-wbs-3xn/demo-query-juriste-ia-recherche-juridique"
            @click.prevent="openCalendlyDemo"
          >
            Réserver une démo
          </a>
          <p class="cta-foot">Tarifs sur mesure, adaptés à votre structure</p>
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-logo-section">
          <img src="/logo-query-juriste-png.png" alt="Query Juriste" class="logo" />
          <p class="footer-description">
            L'IA juridique qui raisonne avec vos besoins.
            Simplifiez vos recherches juridiques.
          </p>
        </div>

        <div class="footer-links-grid">
          <div class="footer-column">
            <h4>Pages</h4>
            <ul>
              <li><a href="https://www.query-juriste.com/">Accueil</a></li>
              <li><a href="https://www.query-juriste.com/blog">Blog</a></li>
              <li><a href="https://www.query-juriste.com/ia">L'IA Query Juriste</a></li>
              <li><a href="https://www.query-juriste.com/faq">FAQ</a></li>
            </ul>
          </div>

          <div class="footer-column">
            <h4>Produit</h4>
            <ul>
              <li><a href="https://www.query-juriste.com/loginPage">Connexion</a></li>
              <li><a href="https://www.query-juriste.com/contactPage">Contact</a></li>
            </ul>
          </div>

          <div class="footer-column">
            <h4>Entreprise</h4>
            <ul>
              <li><a href="https://www.query-juriste.com/mentionsPage">Mentions légales</a></li>
              <li><a href="https://www.query-juriste.com/conditions-utilisation">CGU</a></li>
              <li><a href="https://www.query-juriste.com/conditions-vente">CGV</a></li>
              <li><a href="https://www.query-juriste.com/politique-donnees">Confidentialité</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2025 Query Juriste, tous droits réservés</p>
      </div>
    </footer>
  </div>
</template>

<script>
import BlogNav from "@/components/BlogNav.vue";
import { openCalendlyDemo } from "@/utils/calendly";

export default {
  name: "FAQPage",
  components: { BlogNav },
  methods: {
    openCalendlyDemo,
  },
  metaInfo() {
    return {
      title: "FAQ - Query Juriste",
      meta: [
        {
          name: "description",
          content:
            "Retrouvez toutes les réponses à vos questions sur Query Juriste : fonctionnement, sources, données, langues et support.",
        },
      ],
      link: [{ rel: "canonical", href: "https://www.query-juriste.com/faq" }],
    };
  },
};
</script>

<style scoped>
/* ---------- Tokens ---------- */
:root {
  --bg: #ffffff;
  --text: #1a1a1a;
  --muted: #5e6470;
  --primary: #7e5cf2;
  --primary-600: #625CFB;
  --info: #625CFB;
  --surface: #f7f8fa;
  --border: #e6e8ec;
  --shadow: 0 10px 30px rgba(0,0,0,.12);
  --shadow-sm: 0 4px 16px rgba(0,0,0,.08);
  --radius: 14px;
}

/* ---------- Utilities ---------- */
.text-primary { color: #625CFB; }
.text-info { color: #625CFB; }
.font-bold { font-weight: 700; color: #625CFB; }
.rounded-xl { border-radius: 20px; }
.rounded-pill { border-radius: 999px; }
.shadow-lg { box-shadow: var(--shadow); }
.shadow-sm { box-shadow: var(--shadow-sm); }

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 22px;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform .06s ease, background .2s ease, color .2s ease, border-color .2s ease;
  will-change: transform;
}
.btn:active { transform: translateY(1px); }

.btn-ghost {
  background: transparent;
  border-color: #fff;
  color: #fff;
}
.btn-ghost:hover {
  background: rgba(255,255,255,.08);
  border-color: #fff;
}

/* ---------- Layout wrappers ---------- */
.landing {
  font-family: 'Poppins', ui-sans-serif, system-ui, sans-serif;
  background: var(--bg);
}

/* ---------- HERO ---------- */
.hero {
  padding: 110px 20px 40px;
  background: linear-gradient(180deg, #f8f9fc 0%, #ffffff 100%);
}
.hero-inner {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}
.hero-title {
  font-size: clamp(40px, 6vw, 64px);
  line-height: 1.15;
  margin-bottom: 0.5em;
}
.hero-sub {
  margin: 10px 0 24px;
  color: #5e6470;
  font-size: clamp(16px, 2.6vw, 20px);
}

/* ---------- FAQ SECTION ---------- */
.faq-section {
  padding: 60px 20px 80px;
}
.faq-inner {
  max-width: 800px;
  margin: 0 auto;
}
.faq-item {
  background: #fff;
  border: 1px solid #e6e8ec;
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 24px;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.faq-item:hover {
  box-shadow: 0 8px 30px rgba(0,0,0,.08);
  transform: translateY(-2px);
}
.faq-question {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px;
  padding-left: 20px;
  border-left: 4px solid #625CFB;
}
.faq-answer p {
  font-size: 16px;
  line-height: 1.75;
  color: #5e6470;
  margin: 0 0 16px;
}
.faq-answer p:last-child {
  margin-bottom: 0;
}
.faq-answer strong {
  color: #1a1a1a;
}
.faq-list {
  list-style: none;
  padding: 0;
  margin: 16px 0 0;
}
.faq-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 0;
  font-size: 16px;
  line-height: 1.6;
  color: #5e6470;
}
.faq-list .check {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}
.email-link {
  color: #625CFB;
  text-decoration: none;
  font-weight: 500;
}
.email-link:hover {
  text-decoration: underline;
}

/* ---------- CTA BAND ---------- */
.cta-band {
  background: #625CFB;
  color: #fff;
  margin: 0;
  padding: 50px 20px;
}
.cta-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: center;
}
.cta-title {
  font-weight: 500;
  font-size: clamp(22px, 3.6vw, 32px);
  margin: 0 0 8px;
}
.cta-text { margin: 0; opacity: .95; }
.cta-foot { margin-top: 10px; opacity: .95; }

/* ---------- FOOTER ---------- */
.footer {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  padding: 3rem 0 0 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 3rem;
  display: flex;
  justify-content: space-between;
  gap: 4rem;
  align-items: start;
}

.footer-logo-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-logo-section .logo {
  height: 60px;
  width: 60px;
  align-items: center;
  margin-bottom: 0.5rem;
}

.footer-description {
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 0;
  max-width: 280px;
}

.footer-links-grid {
  display: flex;
  gap: 3rem;
}

.footer-column h4 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-column li {
  margin: 0;
}

.footer-column a {
  color: #6b7280;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s ease;
  line-height: 1.4;
}

.footer-column a:hover {
  color: #625CFB;
}

.footer-bottom {
  margin-top: 2rem;
  padding: 1.5rem 0;
  border-top: 1px solid #e5e7eb;
  background-color: #f8fafc;
}

.footer-bottom p {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 3rem;
  text-align: center;
  color: #6b7280;
  font-size: 0.875rem;
}

/* ---------- Responsive ---------- */
@media (max-width: 1100px) {
  .cta-inner {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .faq-item {
    padding: 24px;
  }
  .faq-question {
    font-size: 18px;
  }
}

@media (max-width: 640px) {
  .hero { padding-top: 80px; }
}

/* Footer responsive */
@media (max-width: 1024px) {
  .footer-links-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem 1.5rem;
  }
}

@media (max-width: 768px) {
  .footer-content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 0 1rem;
    text-align: center;
  }

  .footer-logo-section {
    align-items: center;
  }

  .footer-description {
    text-align: center;
    max-width: none;
  }

  .footer-links-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .footer-column {
    text-align: left;
  }

  .footer-bottom p {
    padding: 0 1rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .footer-links-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .footer-column {
    text-align: center;
  }
}
</style>
